import { CardItem } from '../components/CardItem';

export const initialPageContent: CardItem[] = [
  {
    title: 'Alertas no sistema GAIA',
    description:
      'Informações sobre locais com deslizamentos, inundações e vias obstruídas.',
    image: ['/images/logos/logo_bombeiros.jpg'],
    link: 'https://alertas.bombeirosrolante.com.br/#/',
    source: 'Corpo de Bombeiros Voluntários de Rolante/RS',
    alt: 'Logo do Corpo de Bombeiros Voluntários de Rolante/RS',
  },
  {
    title: 'Estações meteorológicas',
    description: 'Transmissão em tempo real de dados meteorológicos.',
    image: [
      '/images/estacoes/alto_rolante.jpeg',
      '/images/estacoes/bairro_contestado.jpeg',
      '/images/estacoes/bairro_rio_branco.jpeg',
      '/images/estacoes/ilha_nova.jpeg',
      '/images/estacoes/maragato.jpeg',
      '/images/estacoes/inmet_rolante.jpeg',
      '/images/estacoes/ifrs_campus_rolante.jpg',
      '/images/estacoes/morro_grande.jpg',
      '/images/estacoes/mascarada.jpeg',
      '/images/estacoes/mata_olho.jpeg',
      '/images/estacoes/rolantinho.jpeg',
      '/images/estacoes/centro-riozinho.jpeg',
      '/images/estacoes/chuvisqueiro.jpeg',
      '/images/estacoes/bombeiros_voluntarios.jpeg',
      '/images/estacoes/sao_chico_samu.jpg',
      '/images/estacoes/inmet_sao_francisco_de_paula.jpeg',
      '/images/estacoes/rincao_dos_kroeff.jpeg',
      '/images/estacoes/sitio_agua_da_rainha.jpg',
      '/images/estacoes/mapa_estacoes.jpg',
    ],
    link: '/estacoes',
    source: null,
    alt: 'Imagem de mapa com as estações meteorológicas',
  },
  {
    title: 'Níveis dos rios e arroios',
    description:
      'Dados dos sensores de nível da água e localização de réguas linimétricas.',
    image: [
      '/images/postos-fluviometricos/alto_rolante_sensores.jpeg',
      '/images/postos-fluviometricos/new_mascarada.jpeg',
      '/images/postos-fluviometricos/new_rolantinho.jpeg',
      '/images/postos-fluviometricos/alto_rolante.jpeg',
      '/images/postos-fluviometricos/bairro_grassmann.jpeg',
      '/images/postos-fluviometricos/linha_petry.jpeg',
      '/images/postos-fluviometricos/mascarada.jpeg',
      '/images/postos-fluviometricos/mata_olho.jpeg',
      '/images/postos-fluviometricos/praca_matriz.jpeg',
      '/images/postos-fluviometricos/mapa.jpg',
    ],
    link: '/niveis-rios-arroios',
    source: null,
    alt: 'Imagem de mapa com os postos fluviométricos',
  },
  {
    title: 'Localização das chuvas',
    description:
      'Localização das chuvas em tempo real e previsões para os próximos 5 dias no Rio Grande do Sul.',
    image: [
      '/images/mapa/chuvas-em-tempo-real.jpg',
      '/images/mapa/chuvas-proximos-5-dias.jpg',
      '/images/mapa/acumulado-de-chuvas.jpg',
    ],
    link: '/localizacao-chuvas',
    source: 'Windy',
    alt: 'Imagem de radar meteorológico',
  },
  {
    title: 'Alerta para o perigo de deslizamentos de terra',
    description:
      'Índice de risco de deslizamento de terra para os próximos quatro dias.',
    image: ['/images/mapa/georisk.png'],
    link: 'https://georisk.cemaden.gov.br/?lat=-29.6527945&lon=-50.5769391&municipio=4316006&grid=municipal',
    source: 'Centro de Monitoramento em Desastres Naturais (Cemaden).',
    alt: '',
  },
  {
    title: 'Outras informações',
    description:
      'Banco de dados hidrometeorológicos, e mapeamentos relacionados às inundações e deslizamentos de terra.',
    image: [
      '/images/mapa/mapa-deslizamentos.jpg',
      'images/mapa/rede_hidrometeorologica_nacional.png',
      '/images/mapa/mancha_inundacao_2024.jpg',
      '/images/mapa/mapa_interatico_cemaden.png',
      '/images/mapa/mapa-mancha-e-profundidade.jpg',
      '/images/mapa/topobatimetrico.jpg',
      '/images/mapa/cheias-rs.png',
    ],
    link: '/outras-informacoes',
    source: null,
    alt: 'Imagem de mapeamento de deslizamentos',
  },
];
